<div class="row coreteam-item">
    <div class="col-sm-2">
    
    </div>
    <div class="col-sm-3">
        <img src="/assets/images/coreteam/Mariette-250x250xc.jpg" width="250px">
    </div>
    <div class="col-sm-7">
    <h4>Marriette Katarahweire</h4>
    <p><u>Chief Technology Officer (CTO)</u></p>
    Marriette Katarahweire  leads the technical and design team for both web and mobile platforms. She believes users should have rewarding experience in secure and stable environment.
    </div>
    </div>
